var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/lodash/_Map.js
// module id = 9u6A
// module chunks = 1